<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"><path d="M14.007 17.852c5.081 0 9.168 2.535 9.323 5.618l.005.182v.782a13.948 13.948 0 0 1-8.38 3.535 20.82 20.82 0 0 1-.948.021 17.356 17.356 0 0 1-4.182-.642l-.506-.151-.08-.028a13.946 13.946 0 0 1-4.24-2.446l-.336-.291.001-.78c0-3.162 4.162-5.8 9.343-5.8zm.131-10.944.22.002a4.352 4.352 0 1 1-4.498 4.35 4.27 4.27 0 0 1 4.278-4.352z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-user',
});
</script>
